module.exports = __webpack_public_path__ + "img/map_es_mobile.b15c075.png";